module.exports = __webpack_public_path__ + "static/media/world-map.94b75913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/LocationSelect/world-map.jpg
// module id = 1490
// module chunks = 2